module.exports = __webpack_public_path__ + "img/bilibili.7797db3a.png";